export const sortSchedule = (schedule) => schedule.sort((a, b) => {
  if (a.scheduledTime < b.scheduledTime) {
    return -1;
  }
  if (a.scheduledTime > b.scheduledTime) {
    return 1;
  }
  return 0;
});
